module.exports = __webpack_public_path__ + "static/media/logo.44214a25.svg";